import { Plus } from 'lucide-react-native';
import { useWindowDimensions } from 'react-native';
import { Box } from '../../../components/primitives/Box';
import { Button } from '../../../components/primitives/Button';
import { PageHeader } from '../../../components/primitives/PageHeader';
import { HStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { withAlpha } from '../../../theme/colorUtils';
import { tokens } from '../../../theme/tokens';

interface WorkflowsHeaderProps {
  badge?: string;
  title: string;
  subtitle?: string;
  onNewWorkflow?: () => void;
}

export function WorkflowsHeader({
  badge,
  title,
  subtitle,
  onNewWorkflow,
}: Readonly<WorkflowsHeaderProps>) {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const displayBadge = badge ?? t('workflow.page.badge');
  const isTablet = width >= tokens.breakpoints.tablet;

  const rightContent = onNewWorkflow ? (
    <Box style={{ paddingTop: isTablet ? tokens.spacing.xs : 0 }}>
      <Button variant="primary" onPress={onNewWorkflow}>
        <HStack spacing="xs" align="center">
          <Plus size={18} color={colors.primary[900]} strokeWidth={2.5} />
          <Text variant="button" color={colors.primary[900]}>
            {t('workflow.page.newWorkflow')}
          </Text>
        </HStack>
      </Button>
    </Box>
  ) : undefined;

  return (
    <PageHeader
      badge={{
        text: displayBadge,
        backgroundColor: withAlpha(colors.accent.purple[500], 0.13),
        borderColor: withAlpha(colors.accent.purple[500], 0.25),
        textColor: colors.accent.purple[400],
      }}
      title={title}
      subtitle={subtitle}
      rightContent={rightContent}
      paddingBottom="xl"
      marginBottom="xl"
    />
  );
}
